import React from 'react'
import PropTypes from 'prop-types'
import Card from './Card'

function FormCard ({ children, header }) {
  const formHeader = header ? <div className='pb-10 mb-10 border-b border-gray-200 sm:pb-8 sm:mb-8'>{header}</div> : null

  return (
    <Card>
      {formHeader}
      <div className='form-card'>
        {children}
      </div>
    </Card>
  )
}

FormCard.defaultProps = {
  header: null
}

FormCard.propTypes = {
  /**
     * Controls the header content of the card component.
     * It can be anything "renderable" by react - i.e. text and React components (JSX)
     */
  header: PropTypes.node
}

export default FormCard
